"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _ciamAuthWebClientLib = require("@eon-funke/ciam-auth-web-client-lib");
var _config = _interopRequireDefault(require("./config/config"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GlobalErrorHandler = /*#__PURE__*/function () {
  function GlobalErrorHandler() {
    (0, _classCallCheck2.default)(this, GlobalErrorHandler);
    (0, _defineProperty2.default)(this, "errorMsgs", void 0);
    (0, _defineProperty2.default)(this, "errorPage500Path", void 0);
    (0, _defineProperty2.default)(this, "redirectOn500", void 0);
    (0, _defineProperty2.default)(this, "representativeInfoPage", void 0);
    this.errorMsgs = {};
    this.errorPage500Path = null;
    this.redirectOn500 = false;
    this.representativeInfoPage = null;
  }
  return (0, _createClass2.default)(GlobalErrorHandler, null, [{
    key: "getErrorMessage",
    value: function getErrorMessage(name) {
      return this.errorMsgs && this.errorMsgs[name] ? this.errorMsgs[name] : '';
    }
  }, {
    key: "addGlobalErrorMsgs",
    value: function addGlobalErrorMsgs(msgs) {
      this.errorMsgs = _objectSpread(_objectSpread({}, this.errorMsgs), msgs);
    }
  }, {
    key: "handleException",
    value: function handleException(exception) {
      var handleRedirect = function handleRedirect() {
        if (!exception.toRedirect) {
          return;
        }
        localStorage.cscRedirectLock = 1;
        _ciamAuthWebClientLib.SessionHandler.destroyLocalSession();
        if (exception.loginType && [_ciamAuthWebClientLib.loginTypes.loggedIn, _ciamAuthWebClientLib.loginTypes.callCenter].includes(exception.loginType)) {
          var _CONFIG$AEM_CONFIG, _CONFIG$AEM_CONFIG$SS;
          _ciamAuthWebClientLib.SessionHandler.destroyRemoteSso(true, _config.default === null || _config.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG = _config.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG === void 0 ? void 0 : (_CONFIG$AEM_CONFIG$SS = _CONFIG$AEM_CONFIG.SSO) === null || _CONFIG$AEM_CONFIG$SS === void 0 ? void 0 : _CONFIG$AEM_CONFIG$SS.ssoSessionExpiredUrl);
        } else {
          var _CONFIG$AEM_CONFIG2;
          location.replace(_config.default === null || _config.default === void 0 ? void 0 : (_CONFIG$AEM_CONFIG2 = _config.default.AEM_CONFIG) === null || _CONFIG$AEM_CONFIG2 === void 0 ? void 0 : _CONFIG$AEM_CONFIG2.expiredSessionURL);
        }
      };
      var pageName = window && window.location && window.location.pathname ? window.location.pathname.split('/').pop() : '';
      var itIsOopsPage = this.errorPage500Path && (pageName === null || pageName === void 0 ? void 0 : pageName.length) && this.errorPage500Path.indexOf(pageName) !== -1;
      if (exception.name === 'FunkeUnauthenticated' && !_config.default.AEM_CONFIG.isAuthorMode) {
        handleRedirect();
      } else if (exception.name === 'FunkeUnauthorized' && !_config.default.AEM_CONFIG.isAuthorMode) {
        handleRedirect();
      } else if (exception.name === 'FunkeResourseNotAvailabe') {
        // not implemented right now
        // const resources = RestHelper.getRootResources();
        // if (resources.meterreadingauth && !CONFIG.AEM_CONFIG.isAuthorMode) {
        //   handleRedirect();
        // }
      } else if (exception.name === 'Funke500ServerError' && this.redirectOn500 && !itIsOopsPage && !localStorage.cscRedirectLock) {
        location.replace(this.errorPage500Path);
      } else if (exception.name === 'MyNetworkError' && !itIsOopsPage && this.redirectOn500 && !localStorage.cscRedirectLock) {
        location.replace(this.errorPage500Path);
      } else if (exception.name === 'NoImplementation' && !itIsOopsPage && !localStorage.cscRedirectLock) {
        localStorage.cscRedirectLock = 1;
        location.replace(this.representativeInfoPage);
      }
    }
  }]);
}();
(0, _defineProperty2.default)(GlobalErrorHandler, "errorMsgs", void 0);
(0, _defineProperty2.default)(GlobalErrorHandler, "errorPage500Path", void 0);
(0, _defineProperty2.default)(GlobalErrorHandler, "redirectOn500", void 0);
(0, _defineProperty2.default)(GlobalErrorHandler, "representativeInfoPage", void 0);
var _default = exports.default = GlobalErrorHandler;